import { useState } from "react";

const FileUploadInput = ({
  label = "Banner image (if any)",
  id = "file-upload",
  className = "",
  labelClassName = "",
  disabled = false,
  error = "",
  onChange, // Accept onChange as a prop
  accept = "",
  multiple = false,
}) => {
  const [fileName, setFileName] = useState("No file Selected");

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      if (multiple) {
        const fileNames = files.map((file) => file.name).join(", ");
        setFileName(fileNames);
        if (onChange) {
          onChange(files);
        }
      } else {
        setFileName(files[0].name);
        if (onChange) {
          onChange(files[0]);
        }
      }
    } else {
      setFileName("No file Selected");
      if (onChange) {
        onChange(null); // Reset file in parent
      }
    }
  };

  return (
    <div className={`w-full flex flex-col gap-1 line-clamp-1 ${className}`}>
      {label && (
        <label
          htmlFor={id}
          className={`text-body1 font-ptsans line-clamp-1 text-secondary/90 font-medium pl-2 block ${labelClassName}`}
        >
          {label}
        </label>
      )}
      <div
        className={`flex flex-col items-center justify-center border-2 rounded-xl border-dashed py-6 px-4 bg-background_2/80 ${
          disabled
            ? "border-gray-300 cursor-not-allowed opacity-70"
            : "border-secondary/35"
        }`}
      >
        <input
          type="file"
          id={id}
          className="hidden"
          onChange={handleFileChange}
          disabled={disabled}
          accept={accept}
          multiple={multiple}
        />
        <label
          htmlFor={id}
          className={`cursor-pointer px-4 py-2 rounded-lg transition ${
            disabled
              ? "bg-gray-400 text-gray-700 cursor-not-allowed"
              : "bg-secondary/95  text-background hover:bg-secondary/70"
          }`}
        >
          Browse
        </label>
        <p className="text-caption font-ptsans line-clamp-4 text-secondary/70 mt-2">{fileName}</p>
      </div>
      {error && (
        <div className="text-caption text-red-500 font-ptsans pl-2">
          {error}
        </div>
      )}
    </div>
  );
};

export default FileUploadInput;
